import axios from 'axios'
import { isDebug } from '../utils/env'
import { signOut, getAuthHeaders } from 'bxl-auth'

export const metamorphUrl = isDebug()
  ? 'https://metamorph.bybieyang.com/dev'
  : 'https://metamorph.bybieyang.com'

const metamorphClient = axios.create({
  baseURL: metamorphUrl,
  // withCredentials: true,
})

metamorphClient.interceptors.request.use(
  (config: any) => {
    if (config.method === 'get') {
      // fix axios issue: https://github.com/axios/axios/issues/86
      config.data = {}
    }
    config.headers = {
        ...config.headers,
        ...getAuthHeaders()
    }
    return config
  },
  (error: any) => {
    return error
  }
)

// 添加响应拦截器
metamorphClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error?.response?.status === 401) {
      signOut()
      window.location.replace('#/login')
    }
    return Promise.reject(error)
  }
)

export default metamorphClient
